import type { Paginated } from '_shared/_api/pagination/responses/paginated-response';
import PaginatedResponse from '_shared/_api/pagination/responses/paginated-response';
import { api } from '_shared/_stores/api';
import { logSchemaFailure } from '_shared/_utilities/log-schema-failure';
import UserCoworkerQuery from 'users/information/coworker-information/_api/commands/query-user-coworker-api-request';
import UserCoworkerSchema, { UserCoworkerJSON } from 'users/information/coworker-information/_schemas/user-coworker-schema';
import z from 'zod';

export const userCoworkerApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserCoworkers: (
      build.query<Paginated<UserCoworkerJSON>, UserCoworkerQuery>({
        query: (query: UserCoworkerQuery) => ({
          url: 'users/coworkers',
          params: query.searchParams
        }),
        rawResponseSchema: z.array(UserCoworkerSchema.UserCoworkerJSONZ),
      onSchemaFailure: logSchemaFailure,
        transformResponse: (response: UserCoworkerJSON[], meta): Paginated<UserCoworkerJSON> => {
          const headers = meta?.response?.headers.get('x-pagination') ?? '';
          return {
            data: response,
            headers: PaginatedResponse.parsePaginationHeader(headers)
          };
        },
        providesTags: (result) =>
          result
            ? [
                // Tag each item
                ...result?.data?.map(item => ({
                  type: "UserCoworker" as const,
                  id: item.id ?? undefined,
              })) ?? [],
                // Tag the list itself
                { type: "UserCoworker" as const, id: "LIST" },
              ]
            : [{ type: "UserCoworker" as const, id: "LIST" }],
      })
    )
  })
});

export const {
  useGetUserCoworkersQuery
} = userCoworkerApi;
